import { Link, useLocation, useNavigate } from "react-router-dom";

function EventsBottomCardButtons  ({googleCalendarId,listOfUserSubmissions,eventId,eventSeriesId,event_title,event_series_title})   {
    const navigate = useNavigate();
  return (
    <div className="overflow-hidden  bg-white shadow sm:rounded-lg p-4 flex flex-col gap-4">
    <div className="flex justify-items-start gap-4 flex-col md:flex-row md:justify-between">
       
        <button
          className="rounded-lg text-md hover:shadow-lg px-4 py-2 bg-slate-500 text-white flex items-center gap-2"
          onMouseDown={() => {
             navigate(`/${event_series_title?.toLowerCase().replace(/\s+/g, "-")}/events-series/${eventSeriesId}/event/${eventId}/edit`, { replace: true })
          }}
        >
          <svg
            version="1.1"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            className="w-6 h-6"
          >
            <g>
              <path d="m91.668 24.594-16.262-16.262-11.266 11.27 16.258 16.258z" />
              <path d="m25 75 17.887-1.625 30.777-30.781-16.258-16.258-30.781 30.777z" />
              <path
                d="m62.5 91.668h-54.168v-8.3359h54.168z"
                fillRule="evenodd"
              />
            </g>
          </svg>
          <span>Edit Event</span>
        </button>
        <button className="rounded-lg text-md hover:shadow-lg px-4 py-2 bg-slate-500 text-white flex items-center gap-2">
          <svg
            version="1.1"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path d="m15.656 23 34.344 29.062 34.344-29.062zm-4.6562 3.9062v50.094h78v-50.094l-37.062 31.375c-1.1172 0.94531-2.7578 0.94531-3.875 0z" />
          </svg>

          <span>
            {" "}
            <a
              href={`mailto:info@interactiveworkshops.com?bcc=${listOfUserSubmissions
                ?.map((submission) => submission.email)
                .join(",")}`}
              className=""
            >
              {" "}
              Email All Attendees
            </a>
          </span>
        </button>

        <Link
          to={`https://calendar.google.com/calendar/u/0/r/eventedit/${googleCalendarId}`}
          target="_blank"
        >
          <button className="rounded-lg text-md hover:shadow-lg px-4 py-2 bg-slate-500 text-white flex items-center gap-2 w-full ">
            <svg
              version="1.1"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="w-6 h-6"
            >
              <g>
                <path d="m88.5 10.5h-8.5v6.1016c0 5.3008-4.3008 9.6016-9.6016 9.6016h-1.6992c-5.3008 0-9.6016-4.3008-9.6016-9.6016v-6.1016h-18.098v6.1016c0 5.3008-4.3008 9.6016-9.6016 9.6016h-1.8008c-5.3008 0-9.6016-4.3008-9.6016-9.6016v-6.1016h-8.5c-4.5 0-8.1016 3.6016-8.1016 8.1016v70.801c0 4.5 3.6016 8.1016 8.1016 8.1016h76.898c4.5 0 8.1016-3.6016 8.1016-8.1016l0.003906-70.801c0.10156-4.5-3.5-8.1016-8-8.1016zm-4.1016 70.801c0 2.1992-1.8008 4-4 4h-60.797c-2.1992 0-4-1.8008-4-4v-38.402c0-2.3008 1.8008-4 4-4h60.699c2.1992 0 4 1.8008 4 4v38.402z" />
                <path d="m29.602 21.301h1.6992c2.6016 0 4.6992-2.1016 4.6992-4.6992v-9c0-2.8008-2.3008-5.1016-5.1016-5.1016h-0.89844c-2.8008 0-5.1016 2.3008-5.1016 5.1016v9c0 2.5977 2.1016 4.6992 4.7031 4.6992z" />
                <path d="m68.602 21.301h1.6992c2.6016 0 4.6992-2.1016 4.6992-4.6992v-9c0-2.8008-2.3008-5.1016-5.1016-5.1016h-0.89844c-2.8008 0-5.1016 2.3008-5.1016 5.1016v9c0 2.5977 2.1016 4.6992 4.7031 4.6992z" />
              </g>
            </svg>
            <span>View on Gcal</span>
          </button>
        </Link>
      </div>
      </div>
  );
}

export default EventsBottomCardButtons;